import { useState } from 'react';
import { IconPlus, IconZoomOutline } from '@iwoca/icons';
import { Input, Button } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import clsx from 'clsx';
import { useDashboard } from 'components/Dashboard/Dashboard.context';
import { useLocale } from 'hooks/useLocale';
import { FormProvider, useForm } from 'react-hook-form';
import { TSearchBarFormData } from 'types';

import { RecentSearches } from './RecentSearches/RecentSearches';
import styles from './SearchBar.module.css';

export const SearchBar = () => {
  const {
    searchApplication,
    state: { searchString },
  } = useDashboard();
  const [isFocused, setIsFocused] = useState(false);
  const { isDE } = useLocale();

  const formMethods = useForm<TSearchBarFormData>({
    shouldUnregister: false,
  });

  const { register, handleSubmit, setValue } = formMethods;

  const resetSearchBar = () => {
    formMethods.reset();
    searchApplication();
  };

  const onSubmit = ({ searchString }: TSearchBarFormData) => {
    // TODO: implement later
    // removeFilter(APPLICATION_TABLE_KEYS.status);
    if (searchString.length === 0) {
      resetSearchBar();
    } else {
      searchApplication(searchString);
    }
  };

  const searchStringHasLength =
    formMethods.getValues().searchString?.length > 0;

  const shouldShowClearbutton = searchString || searchStringHasLength;

  const shouldShowSearchButton =
    isFocused || searchString || searchStringHasLength;

  return (
    <FormProvider {...formMethods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={styles.searchForm}
        id="search-bar"
      >
        <Input
          {...register('searchString')}
          className={clsx(styles.searchBar, isDE && styles.deSearchBar)}
          placeholder={t`Search apps...`}
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={() => {
            setTimeout(() => {
              setIsFocused(false);
            }, 100);
          }}
        />
        {shouldShowSearchButton ? (
          <Button
            variant="denim"
            data-testid="searchButton"
            className={styles.buttonSearch}
            onClick={handleSubmit(onSubmit)}
          >
            <IconZoomOutline />
          </Button>
        ) : (
          <Button
            variant="tertiary"
            type="submit"
            className={clsx(styles.button, {
              [styles.searchString]: Boolean(searchString),
            })}
          >
            <IconZoomOutline />
          </Button>
        )}
        {isFocused && <RecentSearches setValue={setValue} />}
        {shouldShowClearbutton && (
          <Button
            variant="tertiary"
            data-testid="clearButton"
            className={styles.buttonClear}
            type="button"
            onClick={resetSearchBar}
          >
            <IconPlus className={styles.clearIcon} />
          </Button>
        )}
      </form>
    </FormProvider>
  );
};
